import * as commitTypes from './commitTypes';
import * as actionTypes from './actionTypes';
import subscriptionsRepository from '../repositories/subscriptions.repository';
import vapidFunctions from '../notifications/vapidFuntions';
import mutations from './mutations';
import authRepository from '../repositories/auth.repository';
import appRepository from '../repositories/app.repository';

export default {
    [actionTypes.LOGOUT]({ commit }) {
        return new Promise((resolve, reject) => {
            commit(commitTypes.SET_USER, null);
            resolve();
        });
    },
    async [actionTypes.SAVE_SUBSCRIPTION]({ state, commit }, subscription) {
        const sr = { ...subscriptionsRepository };
        const payload = { user: state.user.id, ...subscription };
        const { data } = await sr.saveSubscription(payload);
        return data;
    },
    [actionTypes.VERIFY_SUBSCRIPTION]({ state, commit, dispatch }) {
        // navigator.serviceWorker.ready.then(swReg => {
        //     swReg.pushManager.getSubscription().then(subs => {
        //         commit(commitTypes.SET_NOTIFY_SUBS, sub);
        //     });
        // })
        if(state.user.notifications_enabled) {
            dispatch(actionTypes.UPDATE_SUBSCRIPTION);
        }
        // const sr = { ...subscriptionsRepository };
        // sr.getSubscriptions(state.user.id)
        //     .then(resp => {
        //         const hasSubs = !!resp.data.length;
        //         commit(commitTypes.SET_HAS_SUBS, hasSubs);
        //     })
        //     .catch(console.log);
    },
    [actionTypes.LOAD_INITIAL_STATE]({ commit }) {
        const jsonState = localStorage.getItem('bm_state');
        if (!jsonState) return;

        const initialState = JSON.parse(jsonState);
        commit(commitTypes.SET_STATE, initialState);
    },
    [actionTypes.UPDATE_SUBSCRIPTION]({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
                toastr.warning('Las notificaciones no son soportadas por su dispositivo');
                dispatch(actionTypes.SAVE_NOTIFICATIONS_SUPPORT, 'NO');
                return;
            }

            if (Notification.permission === 'denied') {
                dispatch(actionTypes.SAVE_NOTIFICATIONS_ALLOWED, 'NO');
                toastr.warning('Notificaciones bloqueadas por el usuario');
                return;
            }

            if (!('PushManager' in window)) {
                dispatch(actionTypes.SAVE_NOTIFICATIONS_SUPPORT, 'NO');
                toastr.warning('Las notificaciones push no son soportadas por su dispositivo');
                return;
            }

            navigator.serviceWorker.ready.then(swReg => {

                const options = { userVisibleOnly: true };
                const vapidPublicKey = vapidFunctions.getPublicKey();
                if (vapidPublicKey) {
                    options.applicationServerKey = vapidPublicKey;
                }

                // Notification.requestPermission().then(resp => {
                //     if(resp === 'granted') {
                        swReg.pushManager.subscribe(options)
                        .then(subscription => {
                            const key = subscription.getKey('p256dh');
                            const token = subscription.getKey('auth');
                            const data = {
                                endpoint: subscription.endpoint,
                                key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                                token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
                            }
        
                            try {
                                dispatch(actionTypes.SAVE_SUBSCRIPTION, data)
                                    .then(data => {
                                        if(data.status) {
                                            commit(commitTypes.SET_HAS_SUBS, data.status);
                                            toastr.success('Subscripción actualizada satisfactoriamente');
                                            resolve(data);
                                        } else {
                                            reject();
                                            toastr.error(data.msg);
                                        }
                                    });
        
                            } catch (err) {
                                toastr.error(`Ocurrió un error al actualizar la subscripción [${err.message}]`);
                                reject();
                            }
                            
                        })
                        .catch(error => {
                            if (Notification.permission === 'denied') {
                                return toastr.warning('Notificaciones bloqueadas por el usuario');
                            } else {
                                return toastr.error('Ocurrió un error al guardar la subscripción');
                            }
                            reject();
                        });
                    // } else {
                    //     toastr.error('Subscripciones bloqueadas por el navegador');
                    // }
                // });
            });
        });
    },
    async [actionTypes.SAVE_BROWSER_SPECTS]({state}, spects) {
        const ar = {...authRepository};
        const {data} = await ar.saveBrowserSpects(state.user.id, spects);
        return data;
    },
    async [actionTypes.SAVE_NOTIFICATIONS_SUPPORT]({state}, support) {
        const ar = {...authRepository};
        const {data} = await ar.saveNotificationsSupport(state.user.id, {support});

        return data;
    },
    async [actionTypes.SAVE_NOTIFICATIONS_ALLOWED]({state}, allowed) {
        const ar = {...authRepository};
        const {data} = await ar.saveNotificationsAllowed(state.user.id, {allowed});

        return data;
    },
    async [actionTypes.VALIDATE_VERSION]({state, commit}) {
        const ar = {...appRepository};

        try {
            const { data } = await ar.getLastVersion();

            return data.version;
        }catch(err) {
            return null;
        }
        
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js